
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"39.3","height":"25.2","viewBox":"0 0 39.3 25.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#EFEFEA","d":"M19.6 16.1L4.9 1.4c-.2-.2-.6-.2-.9 0L.9 4.5c-.2.2-.2.6 0 .9l18.2 18.4c.2.2.6.2.9 0L38.3 5.5c.1-.1.2-.3.2-.4 0-.2-.1-.3-.2-.4l-3.1-3.1c-.3-.4-.7-.4-1-.1L19.6 16.1z"}})])
          )
        }
      }
    